import { Button } from '@toggle/design-system';
import styled, { css } from 'styled-components';

export const SubmitButton = styled(Button).attrs({
  variant: 'primary',
})`
  position: absolute;
  bottom: 10px;
  right: 16px;
  align-self: flex-end;
`;

export const AlfredButton = styled(Button)<{ $pinned?: boolean }>`
  ${props =>
    props.$pinned &&
    css`
      position: absolute;
      bottom: 8px;
      right: 12px;
    `}
`;
